import CreateCustomShortCut from "@/features/financas/views/Indicadores/widgets/Preferencias/CreateCustomShortcut";
import CreatePreferencias from "@/features/financas/views/Indicadores/widgets/Preferencias/CreatePreferencias";
import PreferenciasTemplate from "@/features/financas/views/Indicadores/widgets/Preferencias/PreferenciasTemplate";
import PreferenciasConciliacao from "@/features/financas/views/Indicadores/widgets/ConciliacaoCard/PreferenciasConciliacao";
import PreferenciasFechamentoDeCaixa from "@/features/financas/views/Indicadores/widgets/FechamentoCaixaCard/PreferenciasFechamentoDeCaixa";
import PreferenciasNotasFiscais from "@/features/financas/views/Indicadores/widgets/NotasFiscaisCard/PreferenciasNotasFiscais";
import PreferenciasPagarEReceber from "@/features/financas/views/Indicadores/widgets/Hoje/PreferenciasPagarEReceber";
import PreferenciasReceitasVencidas from "@/features/financas/views/Indicadores/widgets/ReceitasVencidasCard/PreferenciasReceitasVencidas";
import PreferenciasVendasCanceladas from "@/features/financas/views/Indicadores/widgets/VendasCanceladasCard/PreferenciasVendasCanceladas";
import PreferenciasDRE from "@/features/financas/views/Indicadores/widgets/DREPanel/PreferenciasDRE";
import PreferenciasDesempenhoVendasPanel from "@/features/financas/views/Indicadores/widgets/DesempenhoVendasPanel/PreferenciasDesempenhoVendasPanel";
import PreferenciasFluxoDeCaixa from "@/features/financas/views/Indicadores/widgets/FluxoCaixaPanel/PreferenciasFluxoDeCaixa";
import PreferenciasPainelDeVendas from "@/features/financas/views/Indicadores/widgets/VendasPanel/PreferenciasPanelDeVendas";
import { ContainerModule } from "inversify";
import { getActivePinia } from "pinia";

const preferenciasContainer = new ContainerModule((bind) => {
  bind(PreferenciasTemplate)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasPainelDeVendas)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasConciliacao)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasNotasFiscais)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasPagarEReceber)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasReceitasVencidas)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasFluxoDeCaixa)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasDesempenhoVendasPanel)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasFechamentoDeCaixa)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasVendasCanceladas)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(PreferenciasDRE)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(CreatePreferencias)
    .toSelf()
    .when(() => !!getActivePinia());
  bind(CreateCustomShortCut)
    .toSelf()
    .when(() => !!getActivePinia());
});

export { preferenciasContainer };
